import { executeStandardRequest } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { revenueApiPath } from './queryKeys';
import type {
  GetMonthlyRevenueRequestParams,
  GetMonthlyRevenueResponse,
} from './types/getMonthlyRevenue';

export const getMonthlyRevenue = (params: GetMonthlyRevenueRequestParams) =>
  executeStandardRequest(() =>
    privateHttpClient.get<GetMonthlyRevenueResponse>(revenueApiPath.getMonthlyRevenue, params),
  );
